// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-application--is-ltr .v-data-table__mobile-row__cell{text-align:left}tr{min-height:200px;height:100%}#table-providers .theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>td:first-child{width:97px!important}", ""]);
// Exports
module.exports = exports;
